import { render, staticRenderFns } from "./patientService.vue?vue&type=template&id=81fc62d8&"
import script from "./patientService.vue?vue&type=script&lang=js&"
export * from "./patientService.vue?vue&type=script&lang=js&"
import style0 from "./patientService.vue?vue&type=style&index=0&id=81fc62d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports